import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.substr.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import Vue from 'vue';
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import accountCheck from '@tencent/vft-common/openapp/openapp-account-check';
import { loginService, userService, vipService } from '@vip-activity/business';
import util from '@tencent/vft-common/util';
import { defaultAvatar } from '@vip-activity/ui/components/Avatar/Avatar.vue';
import { removeHttp } from '@vip-activity/base';
import config from '../config';
var _window = window,
    TencentSports = _window.TencentSports;

function dateFormat(val) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';
  var date = new Date(typeof val === 'string' ? val.replace(/-/g, '/') : val); // eslint-disable-next-line no-restricted-globals

  if (isNaN(date.getDate())) return '';
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    // eslint-disable-next-line no-param-reassign
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  } // eslint-disable-next-line no-restricted-syntax


  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      // eslint-disable-next-line no-param-reassign
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr("".concat(o[k]).length));
    }
  }

  return fmt;
}

Vue.mixin({
  data: function data() {
    return _objectSpread(_objectSpread({}, config), {}, {
      loginService: loginService,
      userService: userService,
      vipService: vipService,
      defaultAvatar: defaultAvatar,
      accountCheck: accountCheck
    });
  },
  filters: {
    removeHttp: removeHttp,
    formatNum: util.formatNum
  },
  methods: {
    $openLogin: function $openLogin() {
      this.loginService.openLogin();
    },
    isSchema: function isSchema() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return url.match(/^(txvideo|tenvideo2)/);
    },
    openUrl: function openUrl(url, title) {
      if (!url) {
        return;
      }

      if (this.isSchema(url)) {
        accountCheck.openApp(url);
      } else if (env.isApp) {
        var subUrl = url.indexOf('//') === 0 ? window.location.protocol + url : url;
        atom.invoke('openView', {
          url: "txvideo://v.qq.com/HollywoodH5Activity?url=".concat(encodeURIComponent(subUrl))
        });
      } else if (env.isQQSports) {
        TencentSports.open({
          type: 1,
          param: {
            url: url,
            title: title
          }
        });
      } else {
        window.location.href = url;
      }
    },
    openProperty: function openProperty() {
      var url = 'https://film.qq.com/weixin/v3/asset/index.html?header=0&tab=award&hideTab=1&act_id=2p99d4z9skpy0rxfid86pe4xqu';
      this.openUrl(url, '我的奖品');
    },
    replaceUrl: function replaceUrl(href) {
      var noRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!href) return;

      try {
        var url = window.location.protocol + removeHttp(href);

        if (!window.history.replaceState) {
          window.location.replace(url);
          return;
        }

        window.history.replaceState(null, document.title, url); // 需要替换url同时不刷新网页，则不执行location.replace

        if (!noRefresh) {
          window.location.replace('');
        }
      } catch (e) {
        console.error(e);
      }
    },
    delUrlParams: function delUrlParams(params) {
      var _this = this;

      if (!(params instanceof Array)) {
        // eslint-disable-next-line no-param-reassign
        params = [params];
      }

      params.forEach(function (param) {
        _this.replaceUrl(util.delQueStr(window.location.href, param), true);
      });
    },
    dateFormat: dateFormat
  }
});